import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { Loading } from 'react-style-guide';
import GridsInfinitScroll from '../../gameGrid/containers/GridsInfinitScroll';
import GameContainerHeader from '../../gameLists/components/GameContainerHeader';
import gamesService from '../../gameData/services/gamesService';
import gamesPageLayout from '../constants/layoutConstants';
import gamesApiConstants from '../../gameData/constants/gamesApiConstants';

function SortGameContainer(props) {
  const [displaySort, setDisplaySort] = useState(false);
  const [gamesSortData, setGamesSortData] = useState([]);
  const [selectedApiParams, setSelectedApiParams] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [directToGamesList, setDirectToGameList] = useState(false);
  const [gameSortPosition, setGameSortPosition] = useState(-1);
  const [sortPageContext, setSortPageContext] = useState({});

  const getGamesList = (sortValue, isSubscribed) => {
    const {
      token,
      gameSetTargetId,
      sortPosition,
      pageContext,
      contextCountryRegionId,
      timeOptionsAvailable,
      timeFilters
    } = sortValue;

    setGameSortPosition(sortPosition);
    setSortPageContext(pageContext);
    const sortApiParams = {
      sortToken: token,
      gameSetTargetId,
      startRows: gamesApiConstants.params.startRows,
      maxRows: gamesApiConstants.params.maxRows,
      hasMoreRows: true,
      sortPosition,
      contextCountryRegionId
    };
    if (timeOptionsAvailable) {
      sortApiParams.timeFilter = gamesService.getTimeFilterToken(timeFilters);
    }
    sortApiParams['pageContext.pageId'] = pageContext?.pageId;
    sortApiParams['pageContext.isSeeAllPage'] = true;
    setLoading(true);
    gamesService
      .getGamesList(sortApiParams)
      .then(
        result => {
          if (isSubscribed) {
            if (result?.games) {
              const updatedApiParams = gamesService.buildUpdatedApiParams(result, sortApiParams);
              setDisplaySort(sortValue);
              setSelectedApiParams(updatedApiParams);
              setGamesSortData(() => {
                const updateGameData = result.games;
                return updateGameData;
              });
            }
          }
        },
        error => {
          console.debug(error);
        }
      )
      .finally(() => {
        setLoading(false);
      });
  };

  const {
    match: {
      params: { sortName }
    }
  } = props;

  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) {
      const sortValue = gamesService.getSortValueFromStorage(sortName);
      if (sortValue) {
        const isSortTokenExpired = gamesService.isSortTokenExpired(sortValue);
        if (!isSortTokenExpired) {
          getGamesList(sortValue, isSubscribed);
        } else {
          // / retrieve game sort and update
          gamesService.getGameSortBySortName(sortName, sortValue.gameSortContext).then(sortData => {
            getGamesList(sortData, isSubscribed);
          });
        }
      } else {
        // / back to games list page
        setDirectToGameList(true);
      }
    }

    return () => {
      isSubscribed = false;
    };
  }, [sortName]);

  return directToGamesList ? (
    <Redirect to='/' />
  ) : (
    <div>
      {isLoading ? <Loading /> : null}
      {gamesSortData?.length > 0 && (
        <div className='games-list-container'>
          <GameContainerHeader headerLabel={displaySort.displayName} isSeeAllHidden {...props} />
          <GridsInfinitScroll
            gamesData={gamesSortData}
            pageType={gamesPageLayout.pageType.gameSeeAll}
            apiParams={selectedApiParams}
            gameSortPosition={gameSortPosition}
            sortPageContext={sortPageContext}
            {...props}
          />
        </div>
      )}
    </div>
  );
}

SortGameContainer.propTypes = {
  match: PropTypes.shape({ params: PropTypes.shape({ sortName: PropTypes.string }) }).isRequired,
  translate: PropTypes.func.isRequired
};
export default SortGameContainer;
